const setStoreId = (state, payload) => {
  state.commit("SET_STORE_ID", payload);
};

const setStoreUrlPrefix = (state, payload) => {
  state.commit("SET_STORE_URL_PREFIX", payload);
};

const setStoreViewsObject = (state, payload) => {
  state.commit("SET_STORE_VIEWS_OBJECT", payload);
};

const setCurrentStoreView = (state, payload) => {
  state.commit("SET_CURRENT_STORE_VIEW", payload);
}



export default {
  setStoreId,
  setStoreUrlPrefix,
  setStoreViewsObject,
  setCurrentStoreView
};
